import script from "./TagChip.vue?vue&type=script&setup=true&lang=js"
export * from "./TagChip.vue?vue&type=script&setup=true&lang=js"

import "./TagChip.vue?vue&type=style&index=0&id=845f9b30&lang=css"

const __exports__ = script;

export default __exports__